import { render } from "./Interno_cat.vue?vue&type=template&id=2dab4591&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"personal\":\"data\",\"obtenerPersonal\":\"options\",\"refrescarPersonal\":\"options\"}"
import script from "./Interno_cat.vue?vue&type=script&lang=js"
export * from "./Interno_cat.vue?vue&type=script&lang=js"

import "./Interno_cat.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script